export const LATERALITY_LABELS = {
    LEFT: "Left Eye",
    RIGHT: "Right Eye",
    BOTH: "Both Eyes",
    UNSPECIFIED: "Unspecified Eye",
};

const ORDERED_LABELS = [
    LATERALITY_LABELS.RIGHT,
    LATERALITY_LABELS.LEFT,
    LATERALITY_LABELS.BOTH,
    LATERALITY_LABELS.UNSPECIFIED,
];

const normalizeLateralityLabel = (value) => {
    const normalized = String(value || "")
        .trim()
        .toLowerCase();

    if (
        ["right", "right eye", "od", "re", "rt", "r"].includes(normalized)
    ) {
        return LATERALITY_LABELS.RIGHT;
    }

    if (
        ["left", "left eye", "os", "le", "lt", "l"].includes(normalized)
    ) {
        return LATERALITY_LABELS.LEFT;
    }

    if (
        [
            "both",
            "both eyes",
            "ou",
            "bilateral",
            "bi",
            "both eye",
        ].includes(normalized)
    ) {
        return LATERALITY_LABELS.BOTH;
    }

    return LATERALITY_LABELS.UNSPECIFIED;
};

const getSurgeryName = (surgery = {}) => {
    return (
        surgery.name ||
        surgery.printedName ||
        surgery.type ||
        surgery.procedure ||
        ""
    );
};

const mapSurgeriesForSummary = (surgeries = []) =>
    (surgeries || [])
        .map((surgery) => {
            if (!surgery) return null;
            const name = getSurgeryName(surgery);
            if (!name) return null;
            const lateralitySource =
                surgery.laterality ||
                surgery.eye ||
                surgery.selectedLaterality ||
                "";
            const label = normalizeLateralityLabel(lateralitySource);
            return { name, label };
        })
        .filter(Boolean);

export const buildProcedureDischargeSummaryName = (surgeries = []) => {
    const items = mapSurgeriesForSummary(surgeries);
    if (!items.length) return "";

    const firstLabel = items[0].label;
    const allSameLaterality =
        items.length > 0 &&
        items.every((item) => item.label === firstLabel) &&
        firstLabel !== LATERALITY_LABELS.UNSPECIFIED;

    if (allSameLaterality) {
        return items.map((item) => item.name).join(", + ");
    }

    const grouped = ORDERED_LABELS.map((label) => ({
        label,
        names: items
            .filter((item) => item.label === label)
            .map((item) => item.name),
    })).filter((group) => group.names.length);

    if (!grouped.length) {
        return items.map((item) => item.name).join(", + ");
    }

    return grouped
        .map((group) => `${group.label} - ${group.names.join(", + ")}`)
        .join("; ");
};

